import React, {Component} from 'react';
import GoogleLogin from 'react-google-login'
import pinwheel from '../assets/preloader.gif'
import buttonImg from '../assets/btn_google_signin_dark_normal_web@2x.png'
import Thunk from '../store/Thunk'

class Google extends Component {

  constructor(props) {
    super(props);
    // API_KEY attached to rogerjaffe@mrjaffesclass.com account, OSPS project
    // this.API_KEY = '67465316702-4v0brs71aqesh29ii8ifbdvhmcvlmt68.apps.googleusercontent.com'

    // API_KEY attached to rjaffe-sup@sandi.net account, lop-phhs project
    this.API_KEY = '1008770977658-137j8p8efvj8jrf8m3pf837b70gfoiss.apps.googleusercontent.com'
    this.onSuccess = this.onSuccess.bind(this)
    this.onFailure = this.onFailure.bind(this)
    this.onRequest = this.onRequest.bind(this)
  }

  onSuccess(user) {
    let id_token = user.getAuthResponse().id_token
    this.props.dispatch('AUTH:IN_PROCESS');
    Thunk.auth_user(this.props.firebase, this.props.dispatch, id_token);
  }

  onFailure() {
    this.props.dispatch('AUTH:INVALID_CREDENTIALS')
  }

  onRequest() {

  }

  render() {
    return (
      <div className="text-center">
        {
          (this.props.inProcess) ?
            <div><img className="pinwheel" src={pinwheel} alt="Loading..."></img></div> :
            <GoogleLogin clientId={this.API_KEY}
                         tag="div"
                         type=""
                         style={{}}
                         disabled={this.props.inProcess}
                         className=""
                         isSignedIn={true}
                         onSuccess={this.onSuccess}
                         onFailure={this.onFailure}
                         onRequest={this.onRequest}>
              <img src={buttonImg} className="login-button" alt="Login with Google"/>
            </GoogleLogin>
        }
      </div>
    )
  }

}

export default Google



// WEBPACK FOOTER //
// ./src/views/Google.js